module.exports = __webpack_public_path__ + "static/accounting-24808c00053af5066d7fa985076ccc16.svg";